
/* global jQuery  TimelineMax Power1 */


var $ = jQuery;

var szkoleniaCtr = {
    w: 0,
    tl: null,
    init: function() {
        var me = szkoleniaCtr;
        if ( !$('#certyfikaty > a').length)
            return;
    
        me.initSzkolenia(); 
             
        $(document).on('resizeResponsive', me.initSzkolenia);
    },

    initSzkolenia: function() {
        var $el = $('#certyfikaty > a'),
            w = $('#certyfikaty').outerWidth() / $el.length * 0.85,
            me = szkoleniaCtr;
        me.tl = new TimelineMax({paused: true});
                
        $el.each(function( i ) {
            var d = 0;
            if (i)
                d = '=-0.8'; 
            
            me.tl.to($(this), 1, { left: w * i, opacity: 1, ease: Power1.easeInOut, rotation: (Math.random() - 0.5) * 25 }, d);
        });
        me.tl.play();
    }
};

$(window).on('load', () => {
    szkoleniaCtr.init();
});
